import { ProductCard } from '@/components/ProductCard';
import { EmptyPageBlock } from '@/components/EmptyPageBlock';
import { FetchUrlType, PageViewType, ProductType } from '@/types';
import styles from './FilterProductList.module.scss';

type FilterProductListProps = {
  view: PageViewType;
  isMobile: boolean;
  cards: ProductType[];
  type: FetchUrlType;
};

const getEmptyBlockTitle = (type: FetchUrlType) => {
  switch (type) {
    case FetchUrlType.Favourites:
      return 'Пока нет товаров в избранном';
    default:
      return 'Товары не найдены';
  }
};

const getEmptyBlockDescription = (type: FetchUrlType) => {
  switch (type) {
    case FetchUrlType.Favourites:
      return '';
    default:
      return 'Попробуйте изменить фильтры';
  }
};

export const FilterProductList = ({
  view,
  isMobile,
  cards,
  type,
}: FilterProductListProps) => {
  const showCards = cards && cards.length > 0;

  if (!showCards) {
    return (
      <EmptyPageBlock
        title={getEmptyBlockTitle(type)}
        description={getEmptyBlockDescription(type)}
        className={styles.emptyBlock}
      />
    );
  }

  if (view === PageViewType.List && isMobile) {
    return (
      <div className={styles.list}>
        {cards.map((item) => (
          <ProductCard key={item.id} product={item} isFlex />
        ))}
      </div>
    );
  }

  return (
    <div className={styles.grid}>
      {cards.map((item) => (
        <ProductCard key={item.id} product={item} isFlex isSmall />
      ))}
    </div>
  );
};
